export const queryParamsKeys = Object.freeze({
	videoId: 'v',
	target: 'target',
	typeOfContentView: 'type',
	playlistId: 'playlistId'
});

export const ContentView = Object.freeze({
	PLAYVIEW: 'PLAYVIEW',
	STUDIO: 'studio-playlist',
	PERSONAL: 'personal-playlist',
	FEATURED: 'featured-playlist',
	featurePlaylist: 'feature-playlist',
	CLASSES: 'classes'
});

export const ShortContentView = Object.freeze({
	PLAYVIEW: 'PV',
	STUDIO: 'SPL',
	PERSONAL: 'PPL',
	FEATURED: 'FPL',
	CLASSES: 'CL'
});